import { HttpErrorResponse } from '@angular/common/http'

// Gemeinsame Hilfsfunktionen für Passkeys (siehe bentomax/hawk#596)

const PASSWORD_HINT = 'Die Anmeldung mit Passwort ist weiterhin möglich.'

// Der Nutzer hat den Browser-Dialog abgebrochen, er ist abgelaufen oder ein
// neuer Aufruf hat den laufenden abgelöst (z. B. Button statt Autofill).
// Das ist kein Fehler und wird nicht angezeigt.
export function isPasskeyCancellation(err: unknown): boolean {
  return err instanceof Error && (err.name === 'NotAllowedError' || err.name === 'AbortError')
}

// Verständliche Meldung für einen fehlgeschlagenen Passkey-Login
export function passkeyLoginErrorMessage(err: unknown): string {
  if (err instanceof HttpErrorResponse) {
    switch (err.status) {
      case 0:
        return `Keine Verbindung zum Server. ${PASSWORD_HINT}`
      case 401:
        return `Anmeldung mit Passkey fehlgeschlagen. ${PASSWORD_HINT}`
      case 404:
        return `Die Anmeldung mit Passkey ist derzeit nicht verfügbar. ${PASSWORD_HINT}`
      case 429:
        return 'Zu viele Anmeldeversuche. Bitte warte kurz und versuche es dann erneut.'
      default:
        return `Bei der Anmeldung mit Passkey ist ein Fehler aufgetreten. ${PASSWORD_HINT}`
    }
  }

  return `Der Passkey konnte nicht verwendet werden. ${PASSWORD_HINT}`
}

// Verständliche Meldung für eine fehlgeschlagene Registrierung. Die Fehler der
// Verwaltungs-Endpunkte kommen über den ErrorInterceptor bereits als Text an.
export function passkeyRegistrationErrorMessage(err: unknown): string {
  if (err instanceof Error && err.name === 'InvalidStateError') {
    return 'Auf diesem Gerät bzw. in diesem Passwortmanager ist bereits ein Passkey für dein Konto eingerichtet.'
  }
  if (typeof err === 'string' && err) {
    return `Der Passkey konnte nicht eingerichtet werden (${err}).`
  }

  return 'Der Passkey konnte nicht eingerichtet werden.'
}

// Namensvorschlag aus Browser und Betriebssystem, z. B. „Chrome auf Windows“
export function suggestPasskeyName(userAgent: string = navigator.userAgent): string {
  const browser = [
    { pattern: /Edg(e|A|iOS)?\//, name: 'Edge' },
    { pattern: /Firefox\/|FxiOS\//, name: 'Firefox' },
    { pattern: /Chrome\/|CriOS\//, name: 'Chrome' },
    { pattern: /Safari\//, name: 'Safari' },
  ].find((entry) => entry.pattern.test(userAgent))?.name

  const os = [
    { pattern: /iPhone/, name: 'iPhone' },
    { pattern: /iPad/, name: 'iPad' },
    { pattern: /Android/, name: 'Android' },
    { pattern: /Mac OS X|Macintosh/, name: 'Mac' },
    { pattern: /Windows/, name: 'Windows' },
    { pattern: /CrOS/, name: 'ChromeOS' },
    { pattern: /Linux/, name: 'Linux' },
  ].find((entry) => entry.pattern.test(userAgent))?.name

  if (browser && os) {
    return `${browser} auf ${os}`
  }

  return browser || os || 'Passkey'
}
